<template>
	<div id="header-common" :style="{ backgroundImage: 'url(' + srcImage + ')' , height: tall + 'px' }"  >
		<div class="section-content"  >
			<div class="h1" :class="{ accordionsNot: !isAccordions ,accordionsYes: isAccordions }">
				<h1>{{h1}}</h1>
				<span v-if="h2 != null"> {{h2}} </span>
			</div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'sectionTitle',
	props: [ 'srcImage', 'tall', 'h1', 'h2', 'isAccordions' ]
}
</script>



// WEBPACK FOOTER //
// src/common/components/sectionTitle.vue